const l = {
  name: "XcodeCli11",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.6,26.4c-0.1-0.1-0.1-0.2-0.2-0.4H13c-2.8,0-5-2.2-5-5V7c0-2.8,2.2-5,5-5h10c0.5-0.7,1.3-1.3,2.1-1.6l0,0
			c1.2-0.5,2.6-0.5,3.8,0l0,0l3.7,1.5c1.2,0.5,1.9,1.7,1.9,2.9l0.1,0.1c0.5,0.2,1.1,0,1.3-0.5l0.4-0.9l1.8,0.8l0,0
			c1.5,0.6,2.3,2.4,1.6,3.9l0,0l-1.1,2.8c-0.6,1.5-2.4,2.3-3.9,1.6l0,0l-1.8-0.8l0.4-0.9c0.1-0.3,0.1-0.5,0-0.8l0,0l0,0
			c-0.1-0.2-0.3-0.4-0.5-0.5L32,11.2V21c0,2.8-2.2,5-5,5h-1.2c-0.4,1-1.2,1.7-2.2,2C22,28.5,20.4,27.8,19.6,26.4L19.6,26.4z
			 M25.9,2.2c-0.4,0.2-0.8,0.5-1.1,0.8c1,0.5,1.8,1.2,2.3,2c0.5,0.7,0.9,1.6,0.9,2.5l0.3,0.1l2.6,1.1l0.8-1.8l1.8,0.8
			c0.8,0.3,1.3,0.9,1.6,1.6c0.2,0.4,0.2,0.9,0.2,1.3l0.2,0.1c0.5,0.2,1.1,0,1.3-0.5l1.1-2.8l0,0c0.2-0.5,0-1.1-0.5-1.3L37.2,6
			c-0.8,0.9-2.2,1.3-3.4,0.8L32,6l0.4-0.9c0.2-0.5,0-1.1-0.5-1.3l-3.7-1.5l0,0C27.4,1.9,26.6,1.9,25.9,2.2z M25.5,8.7l0.4-0.9
			C26,7.5,26,6.9,25.4,6.2c-0.5-0.7-1.4-1.4-2.5-1.8L22,4l0,0h-9c-1.7,0-3,1.3-3,3v14c0,1.7,1.3,3,3,3h6.3c0.1-0.3,0.1-0.5,0.3-0.8
			L22,18h-4.4l-2.3,3.5l-1.7-1.1l1.6-2.5H14v-2h2.5l2.3-3.6l-3.2-4.9l1.7-1.1l2.7,4.1l2.7-4.1l1.7,1.1l-3.2,4.9l2,3.1l3.1-6.5
			L25.5,8.7z M21.1,16L20,14.3L18.9,16H21.1z M30,14.1L26.5,24H27c1.7,0,3-1.3,3-3V14.1z M28.2,9.8l-6.9,14.3
			c-0.2,0.4-0.2,0.9,0,1.3c0.3,0.6,1,0.9,1.7,0.7l0,0c0.4-0.1,0.8-0.5,1-0.9l5.2-14.9L28.2,9.8z"/>
		<path class="st0" d="M30,38h2v2h-6v-2h2v-6h-2v-2h4V38z"/>
		<path class="st0" d="M38,38h2v2h-6v-2h2v-6h-2v-2h4V38z"/>
		<path class="st0" d="M16,30h6v2h-2v6h2v2h-6v-2h2v-6h-2V30z"/>
		<path class="st0" d="M8,30h2v8h4v2H8V30z"/>
		<path class="st0" d="M3,30c-1.7,0-3,1.3-3,3v4c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3v-1H4v1c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1v-4
			c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v1h2v-1C6,31.4,4.7,30,3,30z"/>
		<path class="st0" d="M25.3,35c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2S25.3,34.3,25.3,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as XcodeCli11
};
